import React, { useEffect, useState } from "react";
import { searchIcon } from "../../../assets/logos/icons";
import filterNew from "../../../assets/logos/filterNew.png";
import FilterDialog from "../filterDialog/filterDialog";
import "./searchBarHL.css";

const SearchBarHLPure = (props) => {
  const {
    placeholder,
    onSearchChange,
    searchValue,
    onFilterChange,
    onFilterDate,
    statusValueFilter
  } = props;

  const [dates, setDates] = useState({});
  const [selectedValueFilter, setSelectedValueFilter] = useState(statusValueFilter);

  const handleDateChange = (event, field) => {
    setDates({ ...dates, [field]: event.target.value });
  };

  const handleFilterChange = (event) => {

    setSelectedValueFilter(event.target.value);
    onFilterChange && onFilterChange(event);

  };

  useEffect(() => {

    let a = Object.keys(dates).length;
    if (a === 2) {
      onFilterDate && onFilterDate(dates);
    }
  }, [dates]);

  const [showFilterBox, setShowFilterBox] = useState(false);
  const toggleFilterBox = () => {
    setShowFilterBox(!showFilterBox);
  };

  return (
    <>
      <div className="searchBarHL-inputWrapper">
        <img src={searchIcon} className="searchBarHL-iconSearchStyle" alt="Search Icon" />

        <input
          type="text"
          id="search"
          name="search"
          className="searchBarHL-input"
          value={searchValue}
          placeholder={placeholder}
          onChange={onSearchChange}
        />

        {/* <button className="searchBarHL-filterIcon" onClick={toggleFilterBox}>
          <img src={filterNew} className="searchBarHL-filterIconStyle" alt="Filter Icon" />
        </button> */}
      </div>
      {/* {showFilterBox && (
        <FilterDialog
          onClose={toggleFilterBox}
          statusValue={selectedValueFilter}
          onApply={toggleFilterBox}
          onFilterChange={handleFilterChange}
          onDateChange={handleDateChange}
          dates={dates}
        />
      )} */}
    </>
  );
};

export { SearchBarHLPure as default };
